import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "",
  username: "",
  roles: [],
  isLogged: false,
  userId:null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.email = action.payload.email;
      state.username = action.payload.username;
      state.roles = action.payload.roles;
      state.isLogged = action.payload.isLogged;
      state.userId = action.payload.userId;

    },
    removeUser: (state) => {
      state.email = "";
      state.username = "";
      state.roles = [];
      state.isLogged = false;
      state.userId = null;

    },
  },
});

export const { setUser, removeUser } = userSlice.actions;
export default userSlice.reducer;
